<!-- Note Sidebar Container -->
<div class="note-sidebar-wrapper">
  <!-- Main Sidebar (with animation) -->
  <div class="note-sidebar" [@sidebarCollapse]="getSidebarAnimationState()"
    [class.note-sidebar--collapsed]="isCollapsed">

    <!-- Sidebar Header -->
    <div class="note-sidebar__header">
      <!-- Note Icon & Note Info -->
      <div class="note-sidebar__note-info">
        <div class="note-info__icon">
          <mat-icon class="hash-icon">description</mat-icon>
        </div>
        <div class="note-info__details">
          <div class="note-info__module">{{ projectName || 'Note' }}</div>
          <div class="note-info__note-id">Note #{{ noteId || 'New' }}</div>
        </div>
      </div>

      <!-- Collapse Button -->
      <button type="button" class="sidebar-collapse-btn" (click)="collapseSidebar()"
        [attr.aria-label]="'Collapse sidebar'">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>

    <!-- Search Input (View Mode Only) -->
    @if (!isCollapsed && mode === 'view') {
      <div class="note-sidebar__search">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" class="search-input" [value]="searchQuery" (input)="handleSearch($any($event.target).value)"
          [disabled]="mode === 'view' || isReadOnly" placeholder="Search note details..."
          [attr.aria-label]="'Search note details'">
      </div>
    }

    <!-- Sidebar Content (scrollable sections) -->
    @if (!isCollapsed) {
      <div class="note-sidebar__content" [ngClass]="{'note-sidebar__content--no-search': mode !== 'view'}"
        >
        <!-- PRE-STATUS SECTION: SELF ASSIGN / MODULE / REFERENCE (Create Mode Only) -->
        @if (showModuleControls && mode === 'create') {
          <div class="sidebar-section">
            <div class="section-content">
              <!-- Row 1: Self assign toggle -->
              <div class="form-field form-field--inline">
                <label class="field-label">Self assign</label>
                <mat-slide-toggle class="toggle-input b-one-switch" [checked]="$any(noteForm?.get('self_assign')?.value) == 1"
                (change)="onSelfAssignToggle($event)"></mat-slide-toggle>
              </div>
              <!-- Module dropdown (hidden when self-assign is on) -->
              @if (!($any(noteForm?.get('self_assign')?.value) == 1)) {
                <div class="form-field">
                  <label class="field-label">Select Module</label>
                  <div class="custom-select custom-select--module">
                    <select class="select-input" [value]="$any(noteForm?.get('module_id')?.value)"
                      (change)="onModuleChange($any($event.target).value)"
                      [disabled]="isReadOnly || !modules || modules.length === 0">
                      <option [value]="''" disabled [selected]="!$any(noteForm?.get('module_id')?.value)">
                        Select Module
                      </option>
                      @for (m of modules; track m) {
                        <option [value]="m.id">{{ m.name }}</option>
                      }
                    </select>
                    <mat-icon class="select-icon">expand_more</mat-icon>
                  </div>
                </div>
              }
              <!-- Reference Number search (typeahead, hidden when self-assign is on) -->
              @if (!($any(noteForm?.get('self_assign')?.value) == 1)) {
                <div class="form-field">
                  <label class="field-label">Select reference number</label>
                  <ng-select [items]="(referenceSearchResults$ | async) ?? []" bindLabel="name" [typeahead]="referenceSearchInput$"
                    [loading]="referenceSearchLoading" [searchable]="true" [clearable]="true"
                    [disabled]="!noteForm?.get('module_id')?.value || isReadOnly" placeholder="Search..."
                    (change)="onReferenceSelect($event)" class="user-search-select">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="user-option">
                        <span class="user-name">{{ item.name }}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp>
                      <div class="no-results">
                        <mat-icon>search_off</mat-icon>
                        <span>No results</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              }
            </div>
          </div>
        }
        <!-- Status & Priority Section -->
        <div class="sidebar-section">
          <h3 class="section-header">STATUS & PRIORITY</h3>
          <div class="section-content">
            <!-- Status Dropdown (Dynamic from API with colors and lock icons) -->
            <div class="form-field">
              <label class="field-label">Status</label>
              <mat-select class="status-select" [formControl]="$any(noteForm.get('status'))"
                (selectionChange)="handleStatusChange($event)" placeholder="Select status..."
                panelClass="status-select-panel" [disabled]="mode === 'view' || isReadOnly">
                <!-- Custom Trigger: Shows selected status with color dot and lock icon -->
                <mat-select-trigger>
                  <div class="status-trigger-content">
                    <span class="status-color-dot" [style.background-color]="getSelectedStatusColor()">
                    </span>
                    <span class="status-trigger-name">
                      {{ getSelectedStatusName() || 'Select status...' }}
                      @if (getSelectedStatusLocked()) {
                        <mat-icon class="status-lock-icon" inline="true">
                          lock
                        </mat-icon>
                      }
                    </span>
                  </div>
                </mat-select-trigger>
                <!-- Options: Each status with color dot and lock icon -->
                @for (status of statuses; track status) {
                  <mat-option [value]="status.id" class="status-option">
                    <div class="status-item">
                      <span class="status-color-dot" [style.background-color]="status.color">
                      </span>
                      <span class="status-item-name">
                        {{ status.name }}
                        @if (status.lock_status) {
                          <mat-icon class="status-lock-icon" inline="true">
                            lock
                          </mat-icon>
                        }
                      </span>
                    </div>
                  </mat-option>
                }
              </mat-select>
            </div>
            <!-- Priority Dropdown (Matching task exactly - replacing grid) -->
            <div class="form-field">
              <label class="field-label">Priority</label>
              <div class="custom-select">
                <select class="select-input" [formControl]="$any(noteForm.get('priority'))"
                  [disabled]="mode === 'view' || isReadOnly" (change)="handleFieldChange('priority', $event)">
                  <option [value]="1">Low</option>
                  <option [value]="2">Medium</option>
                  <option [value]="3">High</option>
                  <option [value]="4">Urgent</option>
                </select>
                <mat-icon class="select-icon">expand_more</mat-icon>
              </div>
            </div>
          </div>
        </div>
        <!-- Flag Section (Note-specific feature) -->
        <div class="sidebar-section">
          <h3 class="section-header">FLAG</h3>
          <div class="section-content">
            <div class="form-field form-field--inline">
              <label class="field-label">Flag this note</label>
              <mat-slide-toggle class="toggle-input b-one-switch" [checked]="$any(noteForm.get('flag')?.value)"
                (change)="onFlagToggle($event)" [disabled]="mode === 'view' || isReadOnly">
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <!-- Dates Section -->
        @if (createdOn || createdBy) {
          <div class="sidebar-section">
            <h3 class="section-header">DATES</h3>
            <div class="section-content">
              <!-- Created On (Read-only) -->
              @if (createdOn) {
                <div class="form-field">
                  <label class="field-label">Created On</label>
                  <div class="field-value">{{ createdOn | date: 'mediumDate' }}</div>
                </div>
              }
              <!-- Created By (Read-only) -->
              @if (createdBy) {
                <div class="form-field">
                  <label class="field-label">Created By</label>
                  <div class="field-value">{{ createdBy }}</div>
                </div>
              }
            </div>
          </div>
        }
        <!-- Module & Project Details (Read-only in view mode) -->
        @if (moduleLabel || projectName) {
          <div class="sidebar-section">
            <h3 class="section-header">DETAILS</h3>
            <div class="section-content">
              <!-- Module -->
              @if (moduleLabel) {
                <div class="form-field">
                  <label class="field-label">Module</label>
                  <div class="field-value">{{ moduleLabel }}</div>
                </div>
              }
              <!-- Project -->
              @if (projectName) {
                <div class="form-field">
                  <label class="field-label">Project</label>
                  <div class="field-value">{{ projectName }}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

  </div>

  <!-- Collapsed Sidebar Toggle Button -->
  @if (isCollapsed) {
    <button type="button" class="sidebar-toggle-collapsed"
      [@toggleButtonHover]="getToggleButtonAnimationState()" [@fadeInOut] (click)="expandSidebar()"
      (mouseenter)="isToggleButtonHovered = true" (mouseleave)="isToggleButtonHovered = false"
      [attr.aria-label]="'Expand sidebar'">
      <mat-icon>arrow_forward</mat-icon>
    </button>
  }

</div>